<script>
    import { setContext } from 'svelte'
    import { navigate }   from "svelte-routing"
    import _              from 'lodash'
    import * as api       from '../../shared/api.js'
    import * as pages     from '../../shared/pages.js'
    import { company, domains }    from '../../shared/stores.js'
    import DomainDropdown from '../../shared/DomainDropdown.svelte'
    import Dropdown       from '../../shared/Dropdown.svelte'
    import LabeledInput   from '../../shared/LabeledInput.svelte'
    import SectionTitle   from '../../shared/SectionTitle.svelte'
    import Loader         from '../../shared/Loader.svelte'
    import Item           from '../../shared/Item.svelte'
    import Group          from './Group.svelte'
    import CookieImport   from './CookieImport.svelte'

    let active    = -1
    let items     = []
    let buffer    = []
    let domain    = null
    let loading   = false
    let error     = false
    let archetype = empty()
    let importing = false

    const match = /empresa\/([0-9]+)\/cookies\/(.+)/.exec(window.location)
    if(match) {
        domain = $domains.find(it => it.domain === match[2])    
    }

    function empty() {
        return { id: 0, name: '', description: '', required: false, cookies: []}
    }

    function sort(it) {
        return it.name
    }
    
    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }

    function addGroup(group) {
        const obj = _.omitBy(group, i => i === '')

        return api
            .post('/donut/group', { ...obj, domain: domain.id })
            .then(api.toJsonIf200)
            .then(it => {
                archetype = empty()
                buffer    = _.orderBy([...buffer, it], ['name'], ['asc'])
                return it
            })
            .catch(err => {
                if(err.status === 400) {
                    err.json().then(violations => {
                        console.log(violations)
                    })
                }
                return Promise.reject('erro adicionando grupo')
            })

    }

    function addNewCookies(evt) {
        if(evt.detail.cookies) {
            const toAdd = evt.detail.cookies
            const byGroup = _.groupBy(toAdd, it => it.group)
            buffer = update( (cookies, group) => {
                const forGroup = byGroup[group.id]
                if(forGroup) {
                    return [...cookies, ...forGroup]
                }
            })
        } else if(evt.detail.groups) {
            buffer = buffer.concat(evt.detail.groups)
        } else {
            console.log('Nothing was imported')
        }
    }

    function updateCookie(cookie) {

        buffer = buffer.map(group => {
            const other = group.cookies.filter(it => it.id !== cookie.id)
            if(group.id == cookie.group) {
                group.cookies = [...other, cookie]
            } else {
                group.cookies = other
            }
            return group
        })

        active = -1


        // buffer = update(cookie.group, cookies => {
        //     const tmp = cookies.filter(it => it.id !== cookie.id)
        //     return [...tmp, cookie]
        // })
    }

    function removeCookie(cookie) {
        buffer = update(cookie.group, cookies => {
            return cookies.filter(it => it.id !== cookie.id)
        })
    }

    function removeGroup(group) {
        buffer = buffer.filter(g => g.id !== group.id)
    }

    function update(id, fn) {
        const result = []
        _.mergeWith(result, buffer, (objValue, srcValue, key, object, source) => {
            if(key === 'cookies' && object.id === id) {
                return fn(srcValue, source)
            }
        })
        return result
    }

    function loadBuffer() {
        // console.log("BUFFER", domain)
        if(domain) {
            loading = true
            api
                .get(`/donuts/${domain.id}`)
                .then(api.toJsonIf200)
                .then(json => {
                    loading = false
                    buffer  = _.orderBy(json, ['name'], ['asc'])
                })
                .catch(err => {
                    error = err
                    loading = false
                })
        } else {
            buffer = []
        }
    }

    function onDomainSelected(selected) {
        const d = selected ? selected.value : null
        // console.log("SELECTED", d)
        if(d) {
            navigate(`/empresa/${$company.id}/cookies/${d.domain}`)
        } else {
            navigate(`/empresa/${$company.id}/cookies`)
        }
        domain = d
    }

    setContext('cookies', {
        cookieRemoved : removeCookie,
        cookieUpdated : updateCookie,
        groupRemoved  : removeGroup,
        groupUpdated  : group => { console.log(group) }
    })

    $: loadBuffer(domain)
</script>

<style>

    .item .ui.label {
        width: 110px;
    }

    .ui.checkbox {
        margin: 1em 0 1em 135px;
    }

    .ui.checkbox label {
        font-size: 18px !important;
    }

    .item {
        margin: 1em 0;
    }   
</style>

<svelte:head>
	<title>Dogma / {$company.name} / Cookies</title>
</svelte:head>
{#if loading || error}
    <Loader {error} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>
        Cookies {#if domain} para {domain.domain} {/if}
    </SectionTitle>

    <DomainDropdown {domain} {onDomainSelected} />

    {#if domain}
        <CookieImport {domain} groups={buffer} bind:active={importing} on:import={ addNewCookies }></CookieImport>
    {/if}

    {#if !importing}
        <div class="ui raised segments">
            <Item item={archetype} bind:active={active} {isDirty} onUpdate={addGroup} disabled={!domain} debug={false}>
                <div slot="primary">
                    <div class="item">
                        <div class="ui toggle big checkbox">
                            <input type="checkbox" bind:checked={archetype.required}>
                            <label>Obrigatório</label>
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui labeled big input" >
                        <div class="ui label">Nome</div>
                            <input  bind:value={archetype.name}
                                    type="text"
                                    autocomplete="false">
                        </div>
                    </div>
                    <div class="item">
                        <div class="ui labeled big input" >
                        <div class="ui label">Descrição</div>
                            <input  bind:value={archetype.description}
                                    type="text" 
                                    autocomplete="false">
                        </div>
                    </div>
                </div>        
            </Item>
            {#if !domain}
                <div class="ui segment">
                    <div class="ui big message">
                        Selecione um domínio
                    </div>
                </div>
            {:else if !buffer || buffer.length === 0}
                <div class="ui segment">
                    <div class="ui big message">
                        Crie um grupo para organizar seus cookies
                    </div>
                </div>
            {/if}
            {#each buffer as group (group.id)}
                <Group bind:item={group} 
                       bind:active={active} 
                       groups={buffer}/>
            {/each}
        </div>
    {/if}          
{/if}